import { refreshAccessToken, getAccessToken } from '../../auth'

let isAlreadyFetchingAccessToken = false
let subscribers = []

function onAccessTokenFetched (token) {
  subscribers = subscribers.filter(callback => callback(token))
}

function addSubscriber (callback) {
  subscribers.push(callback)
}

export default (instance) => {
  instance.interceptors.request.use(
    (config) => {
      const token = getAccessToken()

      if (token && !config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${token}`
      }
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  instance.interceptors.response.use(function (response) {
    return response
  }, function (error) {
    const { config, response } = error
    const originalRequest = config

    if (response && response.status === 401 && window.location.pathname !== '/login' && window.location.pathname !== '/secure') {
      if (!isAlreadyFetchingAccessToken) {
        isAlreadyFetchingAccessToken = true
        refreshAccessToken().then((token) => {
          if (token) {
            isAlreadyFetchingAccessToken = false
            onAccessTokenFetched(token)
          }
        })
      }

      const retryOriginalRequest = new Promise((resolve) => {
        addSubscriber(token => {
          originalRequest.headers.Authorization = 'Bearer ' + token
          resolve(instance(originalRequest))
        })
      })
      return retryOriginalRequest
    }
    return Promise.reject(error)
  })
}



// WEBPACK FOOTER //
// ./src/services/api/http/interceptors/token.js